export const digitsOf = (text)=>text.replace(/[^0-9]/g, '');
const withoutPreviousDigit = (value, caret)=>caret === value.length ? value.slice(1) : value.slice(0, -1);
export const resolveBoxChange = (param, codeLength)=>{
    let { value, caret, previous } = param;
    const allDigits = digitsOf(value);
    if (allDigits.length === codeLength || !previous || value.length < 2) {
        return allDigits;
    }
    return digitsOf(withoutPreviousDigit(value, caret)) || previous;
};
